import { Button, UIHeading2 } from '@cian/ui-kit';

import { type PropsWithChildren, forwardRef } from 'react';

import styles from './OtherCards.css';

type OtherCardsProps = {
  hasNextPage: boolean;
  isLoading: boolean;
  title: string;
  onMoreButtonClick(): void;
};

export const OtherCards = forwardRef<HTMLDivElement, PropsWithChildren<OtherCardsProps>>(
  function OtherCards(props, ref) {
    const { children, isLoading, onMoreButtonClick, title, hasNextPage } = props;

    return (
      <div data-testid="listing.other-cards" ref={ref}>
        <div className={styles['heading-wrapper']}>
          <UIHeading2>{title}</UIHeading2>
        </div>
        {children}
        {hasNextPage && (
          <div className={styles['more-button-wrapper']}>
            <Button disabled={isLoading} loading={isLoading} theme="stroke_secondary" onClick={onMoreButtonClick}>
              Показать ещё
            </Button>
          </div>
        )}
      </div>
    );
  },
);
